import Vue from 'vue';
import Page from './pages/Page';
import {initCtaGradient} from './modules/cta';
import {initScrollReveal} from './modules/animations';
import {UtilsBus} from './utils.js';
import {gdprNotice} from './utils/gdpr.js';
import {initGallerySlider} from './modules/gallery';
import {initNav} from './modules/nav';
import {initCarousel} from "./modules/carousel.js";
import iframeEmbeds from './utils/iframeEmbeds';
import {tabs} from './modules/tabs';
import {accordion} from './modules/accordion';
import {slider} from './modules/slider';
import lozad from 'lozad'

Vue.config.productionTip = false;

const eventHub = new Vue();
UtilsBus.eventHub = eventHub;

window.$ = jQuery;
window.WK = window.WK || {};
window.WK.eventHub = eventHub;
window.WK.utilsBus = UtilsBus;

$(function () {
    initCtaGradient();
    initScrollReveal();
    tabs();
    accordion();
    gdprNotice();
    iframeEmbeds('.js-iframe-embed');
    initGallerySlider({selector: '.js-gallery-slider'});
    initNav();
    initCarousel();
    window.WK.page = new Page();
});

window.addEventListener('load', function () {
    let observer = lozad('.lozad', {
        rootMargin: '50px 0px',
        loaded: function (el) {
            el.classList.add('loaded');
        }
    });
    observer.observe();
});
